import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import {
  createPhaseInProjectTemplate,
  CreatePhaseInProjectTemplatePayload,
} from '../../actions';
import {
  createProjectTemplateProjectPhase,
  setProjectTemplateActiveRecord,
  setupSpacesOnProjectTemplate,
} from '../../slices';
import { createTemplateTaskWithParentProps } from '../task/create';

export function* setupProjectPhaseRelatedEntity(
  projectPhaseId: number,
  projectPhaseName?: string,
) {
  yield put(
    setupSpacesOnProjectTemplate({
      [projectPhaseId]: {
        spaceId: projectPhaseId,
        spaceName: projectPhaseName,
        spaceTabs: [],
        private: false,
      },
    }),
  );

  yield createTemplateTaskWithParentProps({ projectPhaseId });

  yield put(
    setProjectTemplateActiveRecord({
      id: projectPhaseId,
      type: 'PROJECT_PHASE',
    }),
  );
}

function* createProjectPhaseInTemplateSaga(
  action: StoreActionProps<CreatePhaseInProjectTemplatePayload>,
) {
  const {
    payload: { projectPhase, insertAt, handleFailure, handleSuccess },
  } = action;

  try {
    const projectPhaseId = floatUid();

    const _projectPhase = {
      ...projectPhase,
      projectPhaseId,
    };

    yield put(
      createProjectTemplateProjectPhase({
        projectPhase: _projectPhase,
        insertAt,
      }),
    );

    yield setupProjectPhaseRelatedEntity(
      projectPhaseId,
      projectPhase.projectPhaseName,
    );

    if (handleSuccess) {
      handleSuccess(_projectPhase);
    }
  } catch (error) {
    logger.error('Error in creating a phase', { error });

    message.error('There was an error creating a phase');

    if (handleFailure) {
      handleFailure();
    }
  }
}

export function* watchCreatePhaseInProjectTemplateSaga(): Generator {
  yield takeLatest(
    createPhaseInProjectTemplate.type,
    createProjectPhaseInTemplateSaga,
  );
}
